<div class="flex-col start-start ui-uniform-update-name-dialog">
  <div class="flex-row space-between-center">
    <div>Edit uniform name</div>
    <div class="flex-row center-center c-p icon-18" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </div>
  </div>
  <div [formGroup]="form" class="dialog-content narrower-input">
    <div class="flex-col gap-8 w-100">
      <div>Uniform name</div>
      <input class="ui-input flex-col start-start w-100"
             formControlName="name" 
             placeholder="Enter uniform name"
             [class.invalid]="form.get('name')?.invalid && form.get('name')?.touched">
      <div *ngIf="form.get('name')?.invalid && form.get('name')?.touched" class="validation-msg-block">
        <label class="label validation-label">
          <ng-container *ngIf="form.get('name')?.hasError('required')">
            Field is required
          </ng-container>
          <ng-container *ngIf="form.get('name')?.hasError('minlength')">
            Minimum length is 1 character
          </ng-container>
        </label>
      </div>
    </div>
  </div>
  <div class="flex-row end-center gap-10">
    <ui-button type="primary" text="Save" (clickAction)="save()"></ui-button>
    <ui-preloader [color]="PreloaderColor.blue" [diameter]="20" *ngIf="loading"></ui-preloader>
  </div>
</div> 